export default __webpack_public_path__ + "static/media/rs-testing.0726f525.jpg";